export const en = {
  // Sidebar
  ppp_procedimenti: 'PPP Procedures',

  // Pages / titles
  ppp_lista_titolo: 'PPP Procedures',
  ppp_nuovo_procedimento: 'New procedure',
  ppp_nessun_risultato: 'No procedures found.',
  ppp_cerca_placeholder: 'Search procedure...',

  // Detail
  ppp_torna_lista: 'Procedures',
  ppp_fase_attiva: 'Active phase',
  ppp_non_avviato: 'Not started',
  ppp_rup: 'RUP',
  ppp_anno_programmazione: 'Programming year',
  ppp_importo_stimato: 'Estimated amount',
  ppp_ente_concedente: 'Granting Entity',
  ppp_non_trovato: 'Procedure not found.',

  // Tabs
  ppp_tab_fasi: 'Phases',
  ppp_tab_scadenze: 'Deadlines',
  ppp_tab_proposte: 'Proposals',
  ppp_tab_documenti: 'Documents',
  ppp_tab_atti: 'Acts',
  ppp_tab_schema_valutazione: 'Eval. Schema (F8)',
  ppp_tab_verbale_valutazione: 'Comparative Eval. (F9)',

  // Table columns
  ppp_col_codice: 'Code',
  ppp_col_titolo: 'Title',
  ppp_col_ente: 'Granting Entity',
  ppp_col_fase: 'Phase',
  ppp_col_stato: 'Status',
  ppp_col_rup: 'RUP',
  ppp_apri: 'Open',
  ppp_elimina: 'Delete',
  ppp_elimina_titolo: 'Delete procedure',
  ppp_elimina_messaggio: 'Are you sure you want to delete this procedure? This action cannot be undone.',

  // Procedure states
  ppp_stato_bozza: 'Draft',
  ppp_stato_avviato: 'Active',
  ppp_stato_sospeso: 'Suspended',
  ppp_stato_concluso: 'Concluded',
  ppp_stato_archiviato: 'Archived',

  // Phase states
  ppp_fase_non_avviata: 'Not started',
  ppp_fase_in_corso: 'In progress',
  ppp_fase_completata: 'Completed',
  ppp_fase_conclusa: 'Concluded',
  ppp_fase_sospesa: 'Suspended',
  ppp_fase_in_ritardo: 'Overdue',

  // New procedure form
  ppp_form_titolo: 'Title',
  ppp_form_ente_concedente: 'Granting Entity',
  ppp_form_descrizione: 'Description',
  ppp_form_anno: 'Programming year',
  ppp_form_importo: 'Estimated amount (€)',
  ppp_form_settore: 'Sector',
  ppp_form_note: 'Notes',
  ppp_form_rup: 'RUP',
  ppp_form_crea: 'Create procedure',
  ppp_form_annulla: 'Cancel',
  ppp_nuovo_titolo: 'New PPP Procedure',

  // Deadlines
  ppp_scadenze_vuote: 'No deadlines.',
  ppp_scadenza_scade_il: 'Due',
  ppp_scadenza_prorogata_al: 'Extended to',
  ppp_scadenza_scaduta: 'EXPIRED',
  ppp_scadenza_rispettata: 'MET',
  ppp_scadenza_giorni: 'd',
  ppp_scadenza_chiudi: 'Mark as met',
  ppp_scadenza_torna_lista: 'All deadlines',
  ppp_scadenze_rispettate: 'Met deadlines',

  // Extension
  ppp_proroga_titolo: 'Extend deadline',
  ppp_proroga_nuova_data: 'New deadline date',
  ppp_proroga_motivazione: 'Justification (required)',
  ppp_proroga_motivazione_placeholder: 'State the reasons for the extension under applicable law...',
  ppp_proroga_conferma: 'Confirm extension',
  ppp_proroga_azione: 'Extend',
  ppp_proroga_motivo: 'Extension reason',
  ppp_proroga_storico: 'Extension history',
  ppp_proroga_errore_validazione: 'Please enter a future date and a justification of at least 10 characters.',
  ppp_proroga_allegato_label: 'Attachment (optional — e.g. determination or administrative act)',
  ppp_proroga_allegato_hint: 'Accepted formats: PDF, DOC, DOCX, ODT, PNG, JPG — max 50 MB',

  // Delay report
  ppp_report_ritardi_titolo: 'Procedural delay report',
  ppp_report_ritardi_sottotitolo: 'Overdue deadlines in assigned procedures (art. 2 par. 9 L. 241/1990)',
  ppp_report_nessun_ritardo: 'No delays detected.',
  ppp_report_col_procedimento: 'Procedure',
  ppp_report_col_scadenza: 'Deadline',
  ppp_report_col_data: 'Due date',
  ppp_report_col_ritardo: 'Days overdue',
  ppp_report_col_normativa: 'Legal reference',

  // Toast / feedback
  ppp_procedimento_creato: 'Procedure created successfully',
  ppp_procedimento_aggiornato: 'Procedure updated successfully',
  ppp_procedimento_eliminato: 'Procedure deleted successfully',
  ppp_fase_avanza: 'Advance phase',
  ppp_fase_avanza_titolo: 'Advance phase',
  ppp_fase_avanza_messaggio: 'You are about to advance to phase {fase}. Any previous phases not yet started will be marked as concluded. Confirm?',
  ppp_fase_retrocedi: 'Return to this phase',
  ppp_fase_retrocedi_titolo: 'Return to this phase',
  ppp_fase_retrocedi_messaggio: 'You are about to return to phase {fase}. All subsequent phases will be reset to "not started". Confirm?',
  ppp_fase_avanzata: 'Phase advanced successfully',
  ppp_errore_generico: 'An error occurred. Please try again.',

  // RUP
  ppp_rup_non_assegnato: '— No RUP —',
  ppp_modifica: 'edit',
  ppp_annulla: 'Cancel',
  ppp_salva: 'Save',
  ppp_caricamento: 'Loading...',

  // Acts
  ppp_atti_vuoti: 'No acts found.',
  ppp_atti_genera_titolo: 'Generate pre-filled acts',
  ppp_atti_genera_nomina_rup: 'RUP Appointment (art. 15 D.lgs 36/2023)',
  ppp_atti_genera_avvio: 'Resolution/Determination of procedure start',
  ppp_atti_genera_comunicazione: 'Start notice (L. 241/1990)',
  ppp_atti_genera_approvazione_dip: 'DIP approval (art. 41)',
  ppp_atti_genera_selezione_proposte: 'Proposal selection act (art. 193 par. 9)',
  ppp_atti_genera_richiesta_integrazioni: 'Request for additional documents',
  ppp_atti_nomina_rup_warning: 'Assign a RUP before generating the appointment act.',
  ppp_atti_emesso_il: 'Issued on',
  ppp_atti_pubblicato_il: 'Published on',
  ppp_atti_scarica_pdf: 'Download PDF',
  ppp_atti_invia_firma: 'Send for signature',
  ppp_atti_approva: 'Approve',
  ppp_atti_pubblica: 'Publish',
  ppp_atti_genera: 'Generate',
  ppp_atti_tipo: 'Act type',
  ppp_atti_dip_id: 'DIP ID',
  ppp_atti_richiesta_id: 'Integration request ID',
  ppp_atti_avvio_titolo: 'Resolution/Determination of procedure start',
  ppp_atti_comunicazione_avvio_titolo: 'Start notice (arts. 7-8 L. 241/1990)',
  ppp_atti_approvazione_dip_titolo: 'Resolution/Determination of DIP approval',
  ppp_atti_selezione_proposte_titolo: 'Proposal selection act — Final comparative evaluation',
  ppp_atti_richiesta_integrazioni_titolo: 'Formal request for additional documents (art. 193 par. 8)',
  ppp_atti_ufficio_responsabile: 'Responsible office',
  ppp_atti_termine_giorni: 'Completion deadline (days)',
  ppp_atti_modalita_accesso: 'Access to records',
  ppp_atti_sostitutiva_nome: 'Substitute authority (art. 2 par. 9-bis)',
  ppp_atti_sostitutiva_contatto: 'Substitute contact',

  // Assigned procedures view
  ppp_assegnati_titolo: 'Assigned procedures',
  ppp_assegnati_sottotitolo: 'PPP procedures for which you are RUP.',
  ppp_assegnati_sidebar: 'My procedures',

  // Alert configuration
  ppp_alert_titolo: 'Configure deadline alert',
  ppp_alert_azione: 'Alert',
  ppp_alert_giorni_label: 'Days in advance for alert',
  ppp_alert_giorni_hint: 'Value between 1 and 90 days.',

  // Delay report sidebar
  ppp_report_ritardi_sidebar: 'Delay report',

  // Documents
  ppp_doc_carica: 'Upload document',
  ppp_doc_vuoti: 'No documents yet.',
  ppp_doc_scarica: 'Download',
  ppp_doc_scarica_zip: 'Download ZIP',
  ppp_doc_elimina: 'Delete',
  ppp_doc_nuova_versione: 'New version',
  ppp_doc_tipo: 'Document type',
  ppp_doc_ufficio: 'Office',
  ppp_doc_rif_normativo: 'Legal reference',
  ppp_doc_note: 'Notes',
  ppp_doc_versione: 'v',
  ppp_doc_stato_bozza: 'Draft',
  ppp_doc_stato_in_revisione: 'Under review',
  ppp_doc_stato_approvato: 'Approved',
  ppp_doc_stato_pubblicato: 'Published',
  ppp_doc_cambia_stato: 'Change status',
  ppp_doc_checklist_titolo: 'Document checklist',
  ppp_doc_checklist_richiesti: 'Required documents for phase',
  ppp_doc_checklist_completo: 'Complete',
  ppp_doc_checklist_mancante: 'Missing',
  ppp_doc_checklist_vuota: 'No document requirements configured for this phase.',
  ppp_doc_upload_titolo: 'Upload new document',
  ppp_doc_fase_label: 'Phase (optional)',
  ppp_doc_caricato: 'Document uploaded successfully',
  ppp_doc_eliminato: 'Document deleted',
  ppp_doc_stato_aggiornato: 'Status updated',
  ppp_doc_nuova_ver_caricata: 'New version uploaded',
  ppp_doc_obbligatorio: 'Required',
  ppp_doc_facoltativo: 'Optional',
  ppp_doc_mostra_checklist: 'Check requirements',
  ppp_doc_nascondi_checklist: 'Hide requirements',
  ppp_doc_seleziona_tipo: '— Select type —',
  ppp_doc_seleziona_fase: '— No phase —',

  // Three-Year Programme PPP (art. 175 D.lgs 36/2023)
  ppp_programmazione_sidebar: 'Three-Year Programme',
  ppp_programmazione_lista_titolo: 'Three-Year PPP Programme',
  ppp_programmazione_lista_sottotitolo: 'Three-year public works programme management (art. 175 D.lgs 36/2023)',
  ppp_programmazione_nuovo: 'New programme',
  ppp_programmazione_nessun_risultato: 'No three-year programme found.',
  ppp_programmazione_triennio: 'Three-year period',
  ppp_programmazione_col_ente: 'Granting Entity',
  ppp_programmazione_col_triennio: 'Three-year period',
  ppp_programmazione_col_stato: 'Status',
  ppp_programmazione_col_interventi: 'Works',
  ppp_programmazione_col_importo: 'Total amount',
  ppp_programmazione_col_delibera: 'Resolution',

  ppp_prog_stato_bozza: 'Draft',
  ppp_prog_stato_approvato: 'Approved',
  ppp_prog_stato_pubblicato: 'Published',
  ppp_prog_stato_archiviato: 'Archived',

  ppp_prog_form_ente: 'Granting Entity',
  ppp_prog_form_anno: 'Start year of three-year period',
  ppp_prog_form_note: 'Notes',
  ppp_prog_form_crea: 'Create programme',
  ppp_prog_form_annulla: 'Cancel',
  ppp_prog_nuovo_titolo: 'New Three-Year PPP Programme',
  ppp_prog_form_descrizione: 'Enter the entity and start year of the three-year period (e.g. 2026 → 2026-2028).',

  ppp_prog_torna_lista: 'Programme',
  ppp_prog_ente: 'Granting Entity',
  ppp_prog_anno: 'Reference year',
  ppp_prog_note: 'Notes',
  ppp_prog_delibera: 'Approval resolution',
  ppp_prog_data_approvazione: 'Approval date',
  ppp_prog_approvato_da: 'Approved by',
  ppp_prog_url_bdncp: 'BDNCP Publication',
  ppp_prog_non_pubblicato: 'Not yet published',
  ppp_prog_apri_bdncp: 'Open publication',
  ppp_prog_scarica_delibera: 'Download resolution PDF',
  ppp_prog_modifica: 'Edit',
  ppp_prog_salva: 'Save',
  ppp_prog_annulla: 'Cancel',

  ppp_prog_approva: 'Approve resolution',
  ppp_prog_pubblica: 'Publish on BDNCP',
  ppp_prog_approva_titolo: 'Three-Year Programme Approval',
  ppp_prog_pubblica_titolo: 'Publish on BDNCP',
  ppp_prog_numero_delibera: 'Resolution number',
  ppp_prog_data_delibera: 'Resolution date',
  ppp_prog_url_bdncp_label: 'BDNCP publication URL (optional)',
  ppp_prog_conferma_approva: 'Approve',
  ppp_prog_conferma_pubblica: 'Publish',

  ppp_prog_interventi_titolo: 'Works',
  ppp_prog_interventi_vuoti: 'No works added.',
  ppp_prog_intervento_nuovo: 'Add work',
  ppp_prog_intervento_modifica: 'Edit work',
  ppp_prog_intervento_elimina: 'Delete work',
  ppp_prog_intervento_elimina_msg: 'Are you sure you want to delete this work?',
  ppp_prog_int_titolo: 'Work title',
  ppp_prog_int_annualita: 'Year',
  ppp_prog_int_annualita_1: '1st year (Annual List)',
  ppp_prog_int_annualita_2: '2nd year',
  ppp_prog_int_annualita_3: '3rd year',
  ppp_prog_int_importo: 'Amount (€)',
  ppp_prog_int_importo_hint: 'Minimum €150,000 (art. 50 c.1 lett.a)',
  ppp_prog_int_fonte: 'Funding source',
  ppp_prog_int_settore: 'Sector',
  ppp_prog_int_codice: 'Work code (optional)',
  ppp_prog_int_descrizione: 'Description',
  ppp_prog_int_note_fin: 'Funding notes',
  ppp_prog_int_procedimento: 'PPP procedure link',
  ppp_prog_int_procedimento_placeholder: '— No linked procedure —',
  ppp_prog_int_salva: 'Save work',

  ppp_fonte_bilancio_comunale: 'Municipal budget',
  ppp_fonte_mutuo: 'Loan',
  ppp_fonte_fondi_europei: 'European funds',
  ppp_fonte_fondi_regionali: 'Regional funds',
  ppp_fonte_contributo_privato: 'Private contribution',
  ppp_fonte_altro: 'Other',

  ppp_prog_creato: 'Three-year programme created',
  ppp_prog_aggiornato: 'Programme updated',
  ppp_prog_approvato: 'Programme approved successfully',
  ppp_prog_pubblicato: 'Programme published on BDNCP',
  ppp_prog_intervento_aggiunto: 'Work added',
  ppp_prog_intervento_aggiornato: 'Work updated',
  ppp_prog_intervento_eliminato: 'Work deleted',
  ppp_prog_soglia_warning: 'Warning: amount below minimum threshold of €150,000',

  // Public Notice PPP (art. 193 par. 16 D.lgs 36/2023)
  ppp_avviso_sidebar: 'Public Notice (Phase 3)',
  ppp_avviso_titolo_lista: 'PPP Public Notices',
  ppp_avviso_titolo_sottotitolo: 'Public notices for PPP proposal reception (art. 193 par. 16 D.lgs 36/2023)',
  ppp_avviso_nuovo: 'New notice',
  ppp_avviso_nuovo_titolo: 'New PPP Public Notice',
  ppp_avviso_nessuno: 'No public notices found.',
  ppp_avviso_oggetto: 'Subject / Notice title',
  ppp_avviso_oggetto_hint: 'E.g. Exploratory notice for PPP proposal — Underground car park P.za Roma',
  ppp_avviso_stato: 'Status',
  ppp_avviso_procedimento: 'Linked procedure',
  ppp_avviso_procedimento_placeholder: '— No linked procedure —',
  ppp_avviso_descrizione_intervento: 'Work description',
  ppp_avviso_descrizione_hint: 'Description of the work included in the PPP programme (art. 193 par. 16 lett. a)',
  ppp_avviso_requisiti_minimi: 'Minimum proposal requirements',
  ppp_avviso_requisiti_hint: 'Minimum requirements that proposals must meet (art. 193 par. 3 D.lgs 36/2023)',
  ppp_avviso_sopra_soglia_europea: 'Above EU threshold (requires OJEU publication)',
  ppp_avviso_sopra_soglia_label: 'Above EU threshold',
  ppp_avviso_numero_atto: 'Approval act number',
  ppp_avviso_note: 'Notes',
  ppp_avviso_salva: 'Save',
  ppp_avviso_pubblica: 'Publish notice',
  ppp_avviso_pubblica_hint: 'Enter the publication date and proposal submission deadline (minimum 60 days from publication, art. 193 par. 16).',
  ppp_avviso_data_pubblicazione: 'Publication date',
  ppp_avviso_termine_proposte: 'Proposal submission deadline',
  ppp_avviso_termine_proposte_label: 'Proposal submission deadline',
  ppp_avviso_termine_60gg_avviso: '⚠ The deadline must be at least 60 days after the publication date (art. 193 par. 16 D.lgs 36/2023)',
  ppp_avviso_url_amm_trasparente: 'Transparency Portal',
  ppp_avviso_url_bdncp: 'BDNCP',
  ppp_avviso_url_guue: 'OJEU (above EU threshold)',
  ppp_avviso_sezione_generale: 'General information',
  ppp_avviso_sezione_contenuto: 'Mandatory content',
  ppp_avviso_sezione_pubblicazione: 'Publication',
  ppp_avviso_stato_bozza: 'Draft',
  ppp_avviso_stato_pubblicato: 'Published',
  ppp_avviso_stato_scaduto: 'Expired',
  ppp_avviso_creato: 'Public notice created',
  ppp_avviso_aggiornato: 'Public notice updated',
  ppp_avviso_pubblicato_ok: 'Notice published successfully. Procedural deadline updated.',
  ppp_avviso_eliminato: 'Notice deleted',
  // Operator registry
  ppp_avviso_sezione_operatori: 'Interested operators registry',
  ppp_avviso_operatori_hint: 'Economic operators who have requested information about this notice (art. 193 co. 16 D.lgs 36/2023).',
  ppp_avviso_operatori_nessuno: 'No operators registered.',
  ppp_avviso_aggiungi_operatore: 'Register operator',
  ppp_avviso_operatore_ragione_sociale: 'Company name',
  ppp_avviso_operatore_email: 'Email',
  ppp_avviso_operatore_pec: 'PEC',
  ppp_avviso_operatore_telefono: 'Phone',
  ppp_avviso_operatore_data_registrazione: 'Registration date',
  ppp_avviso_operatore_note: 'Notes',
  ppp_avviso_operatore_registrato: 'Operator registered',
  // Integration requests
  ppp_avviso_sezione_richieste: 'Documentary integration requests',
  ppp_avviso_richieste_hint: 'Clarification or integration requests received from operators. The response is published to all interested parties (equal information art. 193 co. 16).',
  ppp_avviso_richieste_nessuna: 'No integration requests.',
  ppp_avviso_aggiungi_richiesta: 'New request',
  ppp_avviso_richiesta_operatore: 'Operator',
  ppp_avviso_richiesta_oggetto: 'Subject',
  ppp_avviso_richiesta_testo: 'Request text',
  ppp_avviso_richiesta_data: 'Request date',
  ppp_avviso_richiesta_stato: 'Status',
  ppp_avviso_richiesta_stato_ricevuta: 'Received',
  ppp_avviso_richiesta_stato_risposta_pubblicata: 'Response published',
  ppp_avviso_richiesta_testo_risposta: 'Response text',
  ppp_avviso_richiesta_data_risposta: 'Response date',
  ppp_avviso_richiesta_pubblica_risposta: 'Publish response',
  ppp_avviso_richiesta_pubblica_hint: 'The response will be published and notified to all operators registered for this notice.',
  ppp_avviso_richiesta_invii: 'Sent to',
  ppp_avviso_richiesta_creata: 'Integration request registered',
  ppp_avviso_risposta_pubblicata: 'Response published and sent to all operators',
  ppp_si: 'Yes',
  ppp_no: 'No',

  // DIP
  ppp_dip_sidebar: 'DIP (Phase 2)',
  ppp_dip_titolo_lista: 'Design Brief Documents (DIP)',
  ppp_dip_nuovo: 'New DIP',
  ppp_dip_nessuno: 'No DIP found.',
  ppp_dip_oggetto: 'Subject / Title',
  ppp_dip_stato: 'Status',
  ppp_dip_procedimento: 'Linked procedure',
  ppp_dip_procedimento_placeholder: '— No linked procedure —',
  ppp_dip_limite_economico: 'Economic limit (€)',
  ppp_dip_data_decisione_avvio: 'Start decision date',
  ppp_dip_data_termine_redazione: 'Drafting deadline (30-60 days)',
  ppp_dip_data_approvazione: 'Approval date',
  ppp_dip_approva: 'Approve DIP',
  ppp_dip_invia_revisione: 'Send for review',
  ppp_dip_elimina: 'Delete DIP',
  ppp_dip_elimina_msg: 'Are you sure you want to delete this DIP?',
  ppp_dip_stato_dei_luoghi: 'Site conditions',
  ppp_dip_stato_dei_luoghi_hint: 'Cadastral data, surveys, GIS models',
  ppp_dip_obiettivi_fabbisogni: 'Objectives and needs',
  ppp_dip_livelli_servizio: 'Service levels and performance requirements',
  ppp_dip_requisiti_tecnici: 'Technical and regulatory requirements',
  ppp_dip_copertura_finanziaria: 'Financial coverage',
  ppp_dip_ha_docfap: 'Above EU threshold (requires DOCFAP)',
  ppp_dip_numero_docfap: 'DOCFAP number/reference',
  ppp_dip_note: 'Notes',
  ppp_dip_salva: 'Save',
  ppp_dip_stato_bozza: 'Draft',
  ppp_dip_stato_in_revisione: 'Under review',
  ppp_dip_stato_approvato: 'Approved',
  ppp_dip_numero_atto: 'Approval act number',
  ppp_dip_numero_atto_hint: 'E.g. Director\'s Decision no. 42/2026',
  ppp_dip_approvato_da: 'Approved by',
  ppp_dip_creato: 'DIP created',
  ppp_dip_aggiornato: 'DIP updated',
  ppp_dip_inviato_revisione: 'DIP sent for review',
  ppp_dip_approvato_ok: 'DIP approved successfully',
  ppp_dip_eliminato: 'DIP deleted',
  ppp_dip_scarica_delibera: 'Download approval PDF',
  ppp_dip_scadenza_redazione: 'DIP drafting deadline',
  ppp_dip_proposte_collegate: 'Linked PPP Proposals — Coherence Check (Phase 4-6)',
  ppp_dip_proposte_collegate_hint: 'Proposals received for this proceeding. Verify coherence with DIP contents (art. 3 Annex I.7).',
  ppp_dip_proposta_senza_titolo: 'Proposal without title',
  ppp_dip_proposta_operatore: 'Economic operator',
  ppp_dip_proposta_presentata: 'Submitted on',
  ppp_proposta_stato_ricevuta: 'Received',
  ppp_proposta_stato_in_valutazione: 'Under review',
  ppp_proposta_stato_ammessa: 'Admitted',
  ppp_proposta_stato_respinta: 'Rejected',
  ppp_proposta_stato_ritirata: 'Withdrawn',
  // PPP Proposals Portal (F04)
  ppp_proposte_sidebar: 'Proposals (Phase 4)',
  ppp_proposte_titolo_lista: 'PPP Proposals Registry',
  ppp_proposte_sottotitolo: 'Reception, filing and formal verification of partnership proposals (art. 193, D.lgs 36/2023)',
  ppp_proposte_nessuna: 'No proposals received.',
  ppp_proposte_filtri: 'Filter proposals',
  ppp_proposte_tutti_procedimenti: '— All proceedings —',
  ppp_proposte_torna_lista: 'Proposals',
  ppp_proposta_registra: 'Register proposal',
  ppp_proposta_nuova_titolo: 'Register new PPP Proposal',
  ppp_proposta_registra_btn: 'File and register',
  ppp_proposta_titolo: 'Proposal title / subject',
  ppp_proposta_titolo_hint: 'E.g. PPP Proposal — Underground car park Town Square',
  ppp_proposta_tipo: 'Proposal type',
  ppp_proposta_tipo_spontanea: 'Unsolicited',
  ppp_proposta_tipo_risposta_avviso: 'Response to notice',
  ppp_proposta_tipo_spontanea_normativa: 'Proposal submitted autonomously by the promoter under art. 193, co. 3, D.lgs 36/2023.',
  ppp_proposta_tipo_risposta_normativa: 'Proposal submitted in response to the public notice under art. 193, co. 16, D.lgs 36/2023.',
  ppp_proposta_avviso_riferimento: 'Reference public notice',
  ppp_proposta_avviso_placeholder: '— Select notice —',
  ppp_proposta_operatore: 'Economic operator (promoter)',
  ppp_proposta_operatore_placeholder: '— Select operator —',
  ppp_proposta_procedimento: 'PPP Proceeding',
  ppp_proposta_procedimento_placeholder: '— Select proceeding —',
  ppp_proposta_data_ricezione: 'Reception date',
  ppp_proposta_data_presentazione: 'Submission date',
  ppp_proposta_importo_spese: 'Costs incurred (€)',
  ppp_proposta_descrizione: 'Proposal description',
  ppp_proposta_descrizione_hint: 'Brief description of the proposed intervention',
  ppp_proposta_note: 'Notes',
  ppp_proposta_protocollo: 'Protocol N°',
  ppp_proposta_prot: 'Protocol',
  ppp_proposta_stato: 'Status',
  ppp_proposta_sezione_protocollazione: 'Filing',
  ppp_proposta_sezione_tipo: 'Type and legal reference',
  ppp_proposta_sezione_operatore: 'Economic operator',
  ppp_proposta_sezione_dati: 'Proposal data',
  ppp_proposta_sezione_valutazione: 'Evaluation outcome',
  ppp_proposta_tab_generale: 'General',
  ppp_proposta_tab_documenti: 'Documents',
  ppp_proposta_tab_valutazione: 'Evaluation',
  ppp_proposta_valuta_btn: 'Record evaluation',
  ppp_proposta_valuta_titolo: 'Proposal evaluation',
  ppp_proposta_valuta_conferma: 'Save evaluation',
  ppp_proposta_esito_valutazione: 'Evaluation outcome',
  ppp_proposta_note_valutazione: 'Evaluation notes',
  ppp_proposta_note_valutazione_hint: 'Justification for the outcome and reference documents...',
  ppp_proposta_registrata: 'Proposal registered and filed successfully',
  ppp_proposta_valutata: 'Evaluation recorded',
  ppp_proposta_scarica_ricevuta: 'Download receipt PDF',

  // Overview dashboard widgets — stat cards
  ppp_widget_procedimenti_attivi: 'Active procedures',
  ppp_widget_procedimenti_totali_sub: '{n} total in system',
  ppp_widget_scadenze_imminenti: 'Deadlines in 7 days',
  ppp_widget_scadenze_oggi_sub: '{n} due today',
  ppp_widget_scadenze_sette_giorni: 'In the next 7 days',
  ppp_widget_scadenze_in_ritardo: 'Overdue deadlines',
  ppp_widget_ritardi_art2: 'Art. 2 co. 9 L. 241/1990',
  ppp_widget_nessun_ritardo: 'No delays detected',

  // Kanban widget
  ppp_widget_kanban_titolo: 'PPP procedure progress',
  ppp_widget_kanban_cerca: 'Search procedure, RUP...',
  ppp_widget_kanban_fasi: 'Phase progress',
  ppp_widget_kanban_vuoto: 'No active procedures.',

  // Upcoming deadlines widget
  ppp_widget_scadenze_lista_titolo: 'Upcoming deadlines',
  ppp_widget_scadenze_lista_vuota: 'No deadlines in the selected period.',
  ppp_widget_oggi: 'TODAY',

  // KPI phases widget
  ppp_widget_kpi_titolo: 'Average time per phase',
  ppp_widget_kpi_sottotitolo: 'Comparison between average actual time and legal deadline for each completed phase',
  ppp_widget_kpi_vuoto: 'No completed phases — data not yet available.',
  ppp_widget_kpi_media: 'Average',
  ppp_widget_kpi_legale: 'legal limit',
  ppp_widget_kpi_nessun_dato: 'No data',
  ppp_widget_kpi_termine_legale: 'Legal deadline',
  ppp_widget_kpi_tempo_medio_ok: 'Average time (on time)',
  ppp_widget_kpi_tempo_medio_ritardo: 'Average time (overdue)',

  // Public Interest Assessment (F05-F06)
  ppp_proposta_stato_interesse_pubblico_dichiarato: 'Public interest declared',

  ppp_valutazione_criteri_titolo: 'Assessment criteria',
  ppp_criterio_coerenza_programmazione: 'Coherence with PPP programming (art. 175, para. 1)',
  ppp_criterio_coerenza_dip: 'Coherence with approved DIP',
  ppp_criterio_fattibilita_tecnica: 'Technical feasibility',
  ppp_criterio_sostenibilita_economica: 'Economic-financial sustainability',
  ppp_criterio_non_valutato: 'Not assessed',
  ppp_criterio_positivo: 'Positive ✓',
  ppp_criterio_negativo: 'Negative ✗',

  ppp_note_ufficio_tecnico: 'Technical Office Notes',
  ppp_note_ufficio_amministrativo: 'Administrative Office Notes',

  // NARS
  ppp_nars_titolo: 'NARS Opinion',
  ppp_nars_richiesto: 'Requested',
  ppp_nars_richiesto_label: 'Request NARS opinion',
  ppp_nars_stato: 'Opinion status',
  ppp_nars_data_richiesta: 'Request date',
  ppp_nars_data_risposta: 'Response date',
  ppp_nars_note: 'NARS notes',
  ppp_nars_stato_non_richiesto: 'Not requested',
  ppp_nars_stato_richiesto: 'Requested',
  ppp_nars_stato_in_attesa: 'Awaiting',
  ppp_nars_stato_ricevuto: 'Received',
  ppp_nars_stato_negativo: 'Negative',

  ppp_valutazione_ip_btn: 'Assessment form',
  ppp_valutazione_ip_titolo: 'Public interest assessment form',
  ppp_valutazione_ip_salvata: 'Assessment form saved',

  ppp_dichiara_interesse_pubblico_btn: 'Declare public interest',
  ppp_dichiara_interesse_pubblico_titolo: 'Declaration of public interest — art. 193, para. 5',
  ppp_dichiara_ip_avviso: 'A director\'s determination declaring public interest will be generated. The proposal will move to "Public interest declared" status and the 60-day timer for competing proposals will start automatically.',
  ppp_dichiara_interesse_pubblico_conferma: 'Generate determination',
  ppp_interesse_pubblico_dichiarato: 'Public interest declaration generated',

  ppp_atto_interesse_pubblico_generato: 'Declaration of public interest determination generated',
  ppp_atto_numero: 'Determination number',
  ppp_atto_note: 'Notes',

  ppp_si: 'Yes',
  ppp_no: 'No',
  ppp_giorni: 'days',
  ppp_seleziona: 'Select',

  // Phase 07 — Publication of public interest proposal
  ppp_proposta_tab_fase07: 'Phase 7 — Publication',
  ppp_fase07_titolo: 'Publication of public interest proposal',
  ppp_fase07_descrizione: 'The proposal declared of public interest is published in the "Transparent Administration" section. The competing proposals collection period begins (minimum 60 days).',
  ppp_fase07_pubblicazione_titolo: 'Publication in Transparent Administration',
  ppp_fase07_data_pubblicazione: 'Publication date',
  ppp_fase07_termine_concorrenti: 'Competing proposals deadline',
  ppp_fase07_giorni_rimanenti: 'Days remaining',
  ppp_fase07_proponenti_titolo: 'Register of competing proponents',
  ppp_fase07_registra_concorrente_btn: 'Register competing proposal',
  ppp_fase07_nessuna_proposta_concorrente: 'No competing proposals received.',
  ppp_fase07_non_ancora_pubblicata: 'The proposal has been declared of public interest but has not yet been published in Transparent Administration. Proceed with publication to start the competing proposals collection period.',
  ppp_fase07_richiede_dichiarazione: 'The proposal must first be declared of public interest (Phase 6) before proceeding with publication.',
  ppp_fase07_pubblica_btn: 'Publish in Transparent Administration',
  ppp_fase07_pubblica_titolo: 'Proposal publication — Phase 7',
  ppp_fase07_pubblica_avviso: 'The proposal will be published in the "Transparent Administration" section. The competing proposals collection deadline will start automatically and a notification will be sent via PEC/email to the original Promoter.',
  ppp_fase07_giorni_termine_label: 'Days for competing proposals deadline (min. 60)',
  ppp_fase07_pubblica_conferma: 'Publish and notify Promoter',
  ppp_fase07_pubblicata: 'Proposal published in Transparent Administration. The Promoter has been notified.',
  ppp_fase07_registra_concorrente_titolo: 'Register competing proposal',
  ppp_fase07_concorrente_registrata: 'Competing proposal registered successfully.',

  // Phase 08 — Comparative Evaluation Schema (art. 193, co. 5 D.lgs 36/2023)
  ppp_schema_sidebar: 'Evaluation Schema (Phase 8)',
  ppp_schema_fase08_label: 'Comparative Evaluation Schema',
  ppp_schema_lista_titolo: 'Comparative Evaluation Schemas',
  ppp_schema_lista_descrizione: 'Schemas to be prepared during the competing proposals publication period (art. 193, co. 5 D.lgs 36/2023).',
  ppp_schema_nuovo_btn: 'New schema',
  ppp_schema_nuovo_titolo: 'New Evaluation Schema',
  ppp_schema_crea_btn: 'Create schema',
  ppp_schema_nessuno: 'No evaluation schema prepared.',
  ppp_schema_nessuno_hint: 'The schema should be prepared during the competing proposals collection period.',
  ppp_schema_titolo: 'Schema title',
  ppp_schema_titolo_placeholder: 'E.g. Comparative evaluation schema — Procedure X',
  ppp_schema_descrizione: 'Description',
  ppp_schema_descrizione_placeholder: 'Purpose and context of the evaluation schema...',
  ppp_schema_note: 'Notes',
  ppp_schema_sezione_generale: 'General information',
  ppp_schema_proposta_promotore: 'Reference Promoter proposal',
  ppp_schema_creato_il: 'Created on',
  ppp_schema_approvato_il: 'Approved on',
  ppp_schema_approvato_da: 'Approved by',
  ppp_schema_non_trovato: 'Evaluation schema not found.',
  ppp_schema_stato_bozza: 'Draft',
  ppp_schema_stato_in_revisione: 'Under review',
  ppp_schema_stato_approvato: 'Approved',
  ppp_schema_criteri_titolo: 'Evaluation criteria',
  ppp_schema_criteri_n: 'criteria',
  ppp_schema_criteri_vuoti: 'No criteria defined. Add criteria or apply a predefined template.',
  ppp_schema_totale_peso: 'Total weights',
  ppp_schema_pesi_ok: '✓ Weights sum to 100 — ready for approval',
  ppp_schema_pesi_troppo: '⚠ Weights exceed 100',
  ppp_schema_pesi_mancanti: 'Missing {n}% to reach 100',
  ppp_schema_avviso_pesi: '⚠ Weights do not sum to 100. To approve the schema, adjust criteria weights to exactly 100.',
  ppp_schema_aggiungi_criterio: 'Add criterion',
  ppp_schema_modifica_criterio: 'Edit criterion',
  ppp_schema_criterio_nome: 'Criterion name',
  ppp_schema_criterio_categoria: 'Regulatory category',
  ppp_schema_criterio_peso: 'Weight (%)',
  ppp_schema_criterio_descrizione: 'Criterion description',
  ppp_schema_template_placeholder: '— Apply predefined template —',
  ppp_schema_template_base: 'Basic template (40/30/30)',
  ppp_schema_template_infrastrutture: 'Infrastructure (40/25/35)',
  ppp_schema_template_servizi: 'Services (30/40/30)',
  ppp_schema_approva_btn: 'Approve schema',
  ppp_schema_approva_titolo: 'Evaluation Schema Approval',
  ppp_schema_approva_avviso: 'Once approved, the schema cannot be modified. Verify all criteria are correct and weights sum to 100.',
  ppp_schema_approva_conferma: 'Approve definitively',
  ppp_schema_note_approvazione: 'Approval notes',
  ppp_schema_note_approvazione_hint: 'RUP/Director notes on schema approval (optional)...',
  ppp_schema_creato: 'Evaluation schema created',
  ppp_schema_aggiornato: 'Evaluation schema updated',
  ppp_schema_approvato: 'Evaluation schema approved successfully',
  ppp_schema_scarica_pdf: 'Download PDF',

  // Phase 10 — Documentary Integrations Request and Preliminary Conference of Services
  ppp_proposta_tab_fase10: 'Phase 10 — Integrations',
  // Phase 11 — Documentary Integrations Evaluation
  ppp_proposta_tab_fase11: 'Phase 11 — Integrations Evaluation',
  // Phase 12 — Admission or Rejection Decision
  ppp_proposta_tab_fase12: 'Phase 12 — Decision',
  // Phase 13 — PFTE Integration and Approval
  ppp_proposta_tab_fase13: 'Phase 13 — PFTE',
  // Phase 14 — Tender Documentation
  ppp_proposta_tab_fase14: 'Phase 14 — Tender Docs',

  ppp_tab_trasparenza: 'Transparency',

  // Transparency — Mandatory Publications
  ppp_trasparenza_titolo: 'Transparency and Mandatory Publications',
  ppp_trasparenza_descrizione: 'Centralised log of all mandatory publications required by PPP regulations.',
  ppp_trasparenza_tab_log: 'Publication Log',
  ppp_trasparenza_elimina_titolo: 'Delete publication',
  ppp_trasparenza_elimina_messaggio: 'Are you sure you want to delete this record? This action cannot be undone.',
  ppp_trasparenza_log_hint: 'Register each mandatory publication made for this procedure. Use the "Register publication" button to add a new record, then filter by type or channel to browse the history.',
  ppp_trasparenza_filtro_tipo: 'Type',
  ppp_trasparenza_filtro_canale: 'Channel',
  ppp_trasparenza_tab_checklist: 'Obligations Checklist',
  ppp_trasparenza_registra_btn: 'Register publication',
  ppp_trasparenza_registra_titolo: 'Register mandatory publication',
  ppp_trasparenza_tipo_label: 'Publication type',
  ppp_trasparenza_canale_label: 'Publication channel',
  ppp_trasparenza_titolo_label: 'Title / Act description',
  ppp_trasparenza_data_label: 'Publication date',
  ppp_trasparenza_url_label: 'Publication URL',
  ppp_trasparenza_riferimento_label: 'Legal reference',
  ppp_trasparenza_note_label: 'Notes',
  ppp_trasparenza_registrata: 'Publication registered successfully.',
  ppp_trasparenza_eliminata: 'Publication deleted.',
  ppp_trasparenza_nessuna: 'No publications registered.',
  ppp_trasparenza_modalita_automatica: 'Automatic',
  ppp_trasparenza_modalita_manuale: 'Manual',
  ppp_trasparenza_checklist_completa: 'All publication obligations have been fulfilled.',
  ppp_trasparenza_checklist_incompleta: 'Some publication obligations have not been fulfilled yet.',
  ppp_trasparenza_filtra_fase: 'Filter by phase',
  ppp_trasparenza_filtra_canale: 'Filter by channel',
  ppp_trasparenza_filtra_tipo: 'Filter by type',
  // Internal PPP notifications
  ppp_notifiche_titolo: 'PPP Notifications',
  ppp_notifiche_nessuna: 'No notifications.',
  ppp_notifiche_solo_non_lette: 'Unread only',
  ppp_notifiche_marca_tutte_lette: 'Mark all as read',
  ppp_notifiche_tutte_lette: 'All notifications have been read.',
  ppp_notifiche_non_lette: 'unread',
  ppp_notifiche_aggiornate: 'All notifications marked as read.',
  // PPP Reporting (task #86c9nq8hu)
  ppp_reportistica_titolo: 'PPP Reporting',
  ppp_reportistica_sottotitolo: 'Procedural compliance and performance reports under D.lgs 36/2023 and L. 241/1990.',
  ppp_reportistica_sidebar: 'Reporting',
  ppp_report_genera: 'Generate report',
  ppp_report_caricamento: 'Loading...',
  ppp_report_seleziona_procedimento: 'Procedure',
  ppp_report_scegli_procedimento: '— Select a procedure —',
  ppp_report_scegli_rup: '— Select a RUP —',
  ppp_report_procedimento: 'Procedure',
  ppp_report_stato: 'Status',
  ppp_report_generato: 'Generated',
  ppp_report_fase: 'Phase',
  ppp_report_data_inizio: 'Start date',
  ppp_report_data_fine: 'End date',
  ppp_report_termine_legale: 'Legal deadline',
  ppp_report_giorni_effettivi: 'Actual days',
  ppp_report_scarto: 'Variance',
  ppp_report_proroga: 'Extension',
  ppp_report_motivazione_proroga: 'Extension reason',
  ppp_report_periodo_inizio: 'From',
  ppp_report_periodo_fine: 'To',
  ppp_report_tutti_gli_stati: 'All statuses',
  ppp_report_avanzamento_titolo: 'Procedure Progress Report',
  ppp_report_avanzamento_desc: 'Per-phase summary with status, dates, and compliance with legal deadlines.',
  ppp_report_termini_titolo: 'Procedural Deadlines Report',
  ppp_report_termini_desc: 'Comparison between legal deadline and actual date for each procedural term (art. 2 co. 9 L. 241/1990).',
  ppp_report_termini_totale: 'Total deadlines',
  ppp_report_termini_rispettate: 'Met',
  ppp_report_termini_in_ritardo: 'Overdue',
  ppp_report_termini_prorogate: 'Extended',
  ppp_report_termini_col_scadenza: 'Deadline',
  ppp_report_termini_col_normativa: 'Legal deadline',
  ppp_report_termini_col_effettiva: 'Effective deadline',
  ppp_report_termini_col_rispettata: 'Met on',
  ppp_report_performance_rup_titolo: 'RUP Performance Report',
  ppp_report_performance_rup_desc: 'Delays, justified extensions, and procedures concluded on time (art. 2, co. 9, L. 241/1990).',
  ppp_report_perf_assegnati: 'Assigned procedures',
  ppp_report_perf_in_corso: 'In progress',
  ppp_report_perf_conclusi_ok: 'Concluded on time',
  ppp_report_perf_ritardi: 'Overdue deadlines',
  ppp_report_perf_proroghe: 'Justified extensions',
  ppp_report_perf_sezione_ritardi: 'Overdue deadlines',
  ppp_report_perf_sezione_proroghe: 'Justified extensions',
  ppp_report_pubblicazioni_titolo: 'Mandatory Publications Report',
  ppp_report_pubblicazioni_desc: 'Publications made per procedure under art. 28, art. 35 D.lgs 36/2023 and D.lgs 33/2013.',
  ppp_report_pubb_totale: 'Total publications',
  ppp_report_pubb_obblighi_assolti: 'Fulfilled obligations',
  ppp_report_pubb_obblighi_mancanti: 'Missing obligations',
  ppp_report_pubb_tipo: 'Publication type',
  ppp_report_pubb_canale: 'Channel',
  ppp_report_pubb_titolo: 'Title',
  ppp_report_pubb_data: 'Date',
  ppp_report_pubb_registrato_da: 'Registered by',
  ppp_report_pubb_url: 'URL',
  ppp_report_statistiche_titolo: 'Aggregate Statistics',
  ppp_report_statistiche_desc: 'Volumes, average times, phase distribution, and RUP performance across procedures.',
  ppp_report_stats_totale: 'Total procedures',
  ppp_report_stats_attivi: 'Active',
  ppp_report_stats_conclusi: 'Concluded',
  ppp_report_stats_sospesi: 'Suspended',
  ppp_report_stats_conformita: 'Deadline compliance',
  ppp_report_stats_ritardi: 'Overdue deadlines',
  ppp_report_stats_prorogate: 'Extended',
  ppp_report_stats_per_fase: 'Distribution by phase',
  ppp_report_stats_per_rup: 'Performance by RUP',
  ppp_report_stats_n_proc: 'N° procedures',
  ppp_report_stats_media_giorni: 'Avg. days',
  ppp_report_stats_conformita_fase: 'Compliance',
};
